/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllIoes200ResponseIoeInner } from './GetAllIoes200ResponseIoeInner';
import {
    GetAllIoes200ResponseIoeInnerFromJSON,
    GetAllIoes200ResponseIoeInnerFromJSONTyped,
    GetAllIoes200ResponseIoeInnerToJSON,
    GetAllIoes200ResponseIoeInnerToJSONTyped,
} from './GetAllIoes200ResponseIoeInner';

/**
 * Successful response
 * @export
 * @interface GetAllIoes200Response
 */
export interface GetAllIoes200Response {
    /**
     * Whether an on-premises Active Directory collector is connected and sending data.
     */
    adConnected?: boolean;
    /**
     * Whether an Entra ID (Azure AD) integration is active for this client.
     */
    entraConnected?: boolean;
    /**
     * List of all IoE checks for this client.
     */
    ioe?: Array<GetAllIoes200ResponseIoeInner>;
}

/**
 * Check if a given object implements the GetAllIoes200Response interface.
 */
export function instanceOfGetAllIoes200Response(value: object): value is GetAllIoes200Response {
    return true;
}

export function GetAllIoes200ResponseFromJSON(json: any): GetAllIoes200Response {
    return GetAllIoes200ResponseFromJSONTyped(json, false);
}

export function GetAllIoes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllIoes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'adConnected': json['adConnected'] == null ? undefined : json['adConnected'],
        'entraConnected': json['entraConnected'] == null ? undefined : json['entraConnected'],
        'ioe': json['ioe'] == null ? undefined : ((json['ioe'] as Array<any>).map(GetAllIoes200ResponseIoeInnerFromJSON)),
    };
}

export function GetAllIoes200ResponseToJSON(json: any): GetAllIoes200Response {
    return GetAllIoes200ResponseToJSONTyped(json, false);
}

export function GetAllIoes200ResponseToJSONTyped(value?: GetAllIoes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adConnected': value['adConnected'],
        'entraConnected': value['entraConnected'],
        'ioe': value['ioe'] == null ? undefined : ((value['ioe'] as Array<any>).map(GetAllIoes200ResponseIoeInnerToJSON)),
    };
}

